import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Suspense } from 'react';
import { NAVBAR_BLUR_BACKGROUND_ROUTES, NAVBAR_TRANSPARENT_ROUTES } from '../../../config/navbar-config';
import { RootPositioning } from './root-positioning';
export interface RootProps {
  children: React.ReactNode;
}

/**
 * Root navbar container
 */
function Root(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <RootContent>{children}</RootContent>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <RootPositioning routesWithBlurBackground={NAVBAR_BLUR_BACKGROUND_ROUTES} routesWithTransparentBackground={NAVBAR_TRANSPARENT_ROUTES}><RootContent>{children}</RootContent></RootPositioning>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Suspense fallback={t1}>{t2}</Suspense>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function RootContent(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("bg-muted/30 fixed top-0 right-0 left-0 z-150 rounded-3xl p-0 shadow-lg sm:top-1.5", "sm:mx-4 sm:p-2.5 sm:shadow-none", "xl:mx-auto xl:max-w-[calc(var(--spacing)*300+20px)] xl:px-2.5", "2xl:max-w-[calc(var(--spacing)*328+20px)]");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}><header className="bg-popover flex h-full flex-1 items-center justify-between rounded-none pr-4 sm:rounded-2xl"><div className="flex w-full items-center justify-between gap-2">{children}</div></header></div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
Root.displayName = 'NavbarRoot';
export { Root };